import './authenticationForm.less';

import React from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { i18n } from 'core/localization';
import { Section } from 'controls/react/layout/section';
import { FormEntryNew } from 'controls/react/form/formEntryNew';
import { AntInput, AntTextArea } from 'controls/react/ant/antInput';
import { AntSelect } from 'controls/react/ant/ant-select/antSelect';
import { TagsSelect } from 'controls/react/tagsSelect';
import { AuthenticationFormProps, AuthenticationType } from 'areas/administration/authentication/types';
import { AuthenticationTypeFields } from './authentication-type-fields/authenticationTypeFields';
import { OAuthValidationNotice } from 'areas/administration/authentication/components/oauth-validation/oauthValidationNotice';

const b = b_.with('authentication-form');

export const AuthenticationForm = observer(({ store }: AuthenticationFormProps) => {
	const { model } = store;

	if (store.loading) {
		return <Section appearance={'none'} contentOverlay={true} overlaySpinner={true} className={b('loading')} />;
	}

	return (
		<Section appearance={'none'} contentPadding={true} childrenPadding={true} className={b()}>
			{store.oauthValidation && <OAuthValidationNotice store={store.oauthValidation} />}
			<FormEntryNew
				label={i18n('Name')}
				placeholder={i18n('Please input name...')}
				hasPlaceholder={true}
				model={model}
				modelField={'name'}
				validator={store.validator}
				disabled={store.readOnly}
			>
				<AntInput autoComplete={'off'} />
			</FormEntryNew>
			<FormEntryNew
				label={i18n('Description')}
				model={model}
				modelField={'description'}
				disabled={store.readOnly}
			>
				<AntTextArea height={60} />
			</FormEntryNew>
			<FormEntryNew label={i18n('Tags')} model={model} modelField={'tags'} disabled={store.readOnly}>
				<TagsSelect accountId={store.accountId} includeSubaccounts={false} />
			</FormEntryNew>
			<FormEntryNew
				label={i18n('Type')}
				placeholder={i18n('Select Authentication type...')}
				hasPlaceholder={true}
				model={model}
				modelField={'authenticationType'}
				validator={store.validator}
				onChange={(value: AuthenticationType) => store.changeType(value)}
				disabled={!store.isCreate}
			>
				<AntSelect options={store.typeOptions} showSearch={true} optionFilterProp={'label'} />
			</FormEntryNew>
			{store.fieldsStore && <AuthenticationTypeFields store={store.fieldsStore} />}
			{!store.isCreate && (
				<FormEntryNew label={'CVID'} model={store} modelField={'id'} disabled={true}>
					<AntInput />
				</FormEntryNew>
			)}
		</Section>
	);
});
